import ConstantHelper from "../../Helpers/ConstantHelper";

const WebDesignPackagesData = [
  {
    id: "1",
    title: "Quick Start Package",
    overview:
      "Perfect for businesses and individuals looking for a stunning online presence.",
    offerPrice: "99",
    actualPrice: "499",
    featuresList: [
      { feature: "Premium Template Selection" },
      { feature: "Up to 10 Unique Pages in each Theme" },
      { feature: "Mobile Responsive Design" },
      { feature: "Online Booking/Reservation System (Optional)" },
      { feature: "E-commerce Integration (Optional)" },
      { feature: "Contact Forms and Lead Generation" },
      { feature: "High-Resolution Images and Graphics" },
      { feature: "Social Media Integration" },
      { feature: "SEO Optimization" },
      { feature: "Blog Setup (Optional)" },
      { feature: "Newsletter Subscription (Optional)" },
      { feature: "Video Integration" },
      { feature: "Custom Domain Connection" },
      { feature: "Content Management System (CMS) (Optional)" },
      { feature: "Elegant Niche Specific Templates" },
      { feature: "Hosting and Security" },
    ],
    orderNowBtn: true,
    OrderUrl: "/theme-store",
    viewDetailsBtn: true,
    CTACall: ConstantHelper.CTACall,
    CTAChat: ConstantHelper.CTAChat,
  },
  {
    id: "2",
    title: "Business Website Package",
    overview:
      "Suitable for mid sized startups who are looking to work with a strong R&D, Creative and marketing team to help develop a unique brand identity, strong digital presense, marketing strategies and help select elements to alter consumer behaviour toawrds their business. These strategies will help to compete directly with some of the top competitors in your target market.",
    offerPrice: "2500",
    actualPrice: "5000",
    featuresList: [
      { feature: "Custom Made, Interactive, Dynamic & High End Design" },
      { feature: "Custom WP (or) Custom PHP Development" },
      { feature: "1 jQuery Slider Banner" },
      { feature: "Up to 10 Custom Made Banner Designs" },
      { feature: "10 Stock Images" },
      { feature: "5 Rounds of Revisions" },
      { feature: "Special Hover Effects" },
      { feature: "Content Management System (CMS)" },
      {
        feature:
          "Online Appointment/Scheduling/Online Ordering Integration (Optional)",
      },
      { feature: "Online Payment Integration (Optional)" },
      { feature: "Multi Lingual (Optional)" },
      { feature: "Custom Dynamic Forms (Optional)" },
      { feature: "Signup Area (For Newsletters, Offers etc.)" },
      { feature: "Search Bar" },
      { feature: "Live Feeds of Social Networks integration (Optional)" },
      { feature: "Mobile Responsive" },
      { feature: "15 Seconds 2D Explainer Video" },
      { feature: "Voice - Over & Sound Effects" },
      { feature: "Professional Script Writing" },
      { feature: "Storyboard" },
      { feature: "SEO Meta Tags" },
      { feature: "FREE 5 Years Domain Name" },
      { feature: "Free Google Friendly Sitemap" },
      { feature: "Complete W3C Certified HTML" },
      { feature: "Industry Specified Team of Expert Designers and Developers" },
      { feature: "Dedicated Accounts Manager" },
      { feature: "Complete Deployment" },
    ],
    orderNowBtn: true,
    viewDetailsBtn: true,
    CTACall: ConstantHelper.CTACall,
    CTAChat: ConstantHelper.CTAChat,
  },
  {
    id: "3",
    title: "Automated Conferencing Portal",
    overview:
      "Allows live conferencing features and custom client/user dashboards for clients with a strong semi-automated admin panel.",
    offerPrice: "5000",
    actualPrice: "9999",
    featuresList: [
      { feature: "Custom Pages and Modules Scoped to Your Requirements" },
      { feature: "Custom Content Management System (CMS)" },
      { feature: "Unique Pages and UI Design" },
      { feature: "Complete Custom Development" },
      { feature: "Process Automation Tools" },
      { feature: "Newsfeed Integration" },
      { feature: "Social Media Plugins Integration" },
      { feature: "Upto 40 Stock images" },
      { feature: "10 Unique Banner Designs" },
      { feature: "JQuery Slider" },
      { feature: "Free Google Friendly Sitemap" },
      { feature: "FREE 5 Years Hosting" },
      { feature: "Custom Email Addresses" },
      { feature: "Social Media Page Designs (Facebook, Twitter, Instagram)" },
      { feature: "Complete W3C Certified HTML" },
      { feature: "Dedicated Accounts Manager" },
      { feature: "Complete Deployment" },
      { feature: "Money Back Guarantee" },
      { feature: "Automated Course Creation" },
      { feature: "Video Conferencing" },
      { feature: "Skills/Certification Tracking" },
      { feature: "Mobile Learning" },
      { feature: "Asynchronous Learning" },
      { feature: "CRM Features" },
      { feature: "Gamification" },
      { feature: "Social Learning/Message Boards" },
      { feature: "Motivational Triggers" },
      { feature: "Forums And Webinars" },
      { feature: "E-commerce And Subscriptions" },
      { feature: "Online Course Booking" },
      { feature: "Excellent Reporting" },
      { feature: "Invoicing Integration" },
      { feature: "Financial Integrations" },
      { feature: "Student Information management" },
      { feature: "Automated communications" },
      { feature: "Learning Management System" },
      { feature: "Quick And Easy Course Scheduling" },
      { feature: "Reporting And Data Analysis" },
      { feature: "Assessment Management & Live Feedback" },
      { feature: "Gradebooks" },
      { feature: "Quick User Integration" },
      { feature: "Easy Payment Methods" },
      { feature: "Online Communities & Social Engagement" },
      { feature: "Curation of Resources And Adding Own Resources" },
      { feature: "Dedicated Accounts Manager" },
    ],
    orderNowBtn: true,
    viewDetailsBtn: true,
    CTACall: ConstantHelper.CTACall,
    CTAChat: ConstantHelper.CTAChat,
  },
  {
    id: "4",
    title: "Custom CRM Portal",
    overview:
      "Suitable for mid sized and strong Enterprises with Custom Dashboard Features, Automation/Intelligence, CRM Features, Sales Automation, Forecasting and Advanced back office intelligent managmement system. (Job Portals, Real Estate Portals, I.T Management Portals, Medical Portals, HRM Portals, CRM Portals, Dating Portals, Management Portals)",
    offerPrice: "7000",
    actualPrice: "14000",
    featuresList: [
      { feature: "Custom Pages and Modules Scoped to Your Requirements" },
      { feature: "Unique Pages and UI Design" },
      { feature: "Complete Custom Development" },
      { feature: "Newsfeed Integration" },
      { feature: "CRM (Customer Relation Management System)" },
      { feature: "Performance and analytics" },
      { feature: "Customization of Personal Details" },
      { feature: "Process management" },
      { feature: "Sales Automation" },
      { feature: "Team Collaboration" },
      { feature: "Marketing Automation" },
      { feature: "Security" },
      { feature: "Integrations" },
      { feature: "Sales Reports" },
      { feature: "Trend Analytics" },
      { feature: "Forecasting" },
      { feature: "Territory Management" },
      { feature: "Account Management" },
      { feature: "Event Integration" },
      { feature: "Advanced Data Security" },
      { feature: "Account Management" },
      { feature: "Opportunity Management" },
      { feature: "Sales Forecasting" },
      { feature: "Quotes" },
      { feature: "Contracts" },
      { feature: "Document Library" },
      { feature: "Case Management" },
      { feature: "Analytics and Dashboards" },
      { feature: "Lead Management" },
      { feature: "Resource Management" },
      { feature: "Analytics" },
      { feature: "Web Intelligence" },
      { feature: "Automated Emails, Invoices & Estimates" },
      { feature: "Automated Split invoicing" },
      { feature: "Automated Combine invoices" },
      { feature: "Invoice templates" },
      { feature: "Financial Reports" },
      { feature: "Generate automated sales reports" },
      { feature: "Core Features" },
      { feature: "Reporting" },
      { feature: "Accounting" },
      { feature: "Tracking and Visibility" },
      { feature: "Centralized Modules" },
      { feature: "Human Resources Management" },
      { feature: "Business Process Management" },
      { feature: "Enterprise Analytics" },
      { feature: "Business Intelligence" },
      { feature: "Centralized Modules" },
      { feature: "Accounting" },
      { feature: "Distribution" },
      { feature: "Business Intelligence" },
      { feature: "Insights" },
      { feature: "Standardization" },
      { feature: "Procurement" },
      { feature: "Reporting and Analytics" },
      { feature: "Projection" },
      { feature: "Enterprise-wide integration" },
      { feature: "Real-Time Operations" },
      { feature: "Problem definition" },
      { feature: "Description of the program’s objectives and scope" },
      { feature: "Assumptions" },
      { feature: "Implementation costs" },
      { feature: "Implementation schedule" },
      { feature: "Development and operational risks" },
      { feature: "Projected benefits" },
      { feature: "Team Members" },
      { feature: "Contracts" },
      { feature: "Infrastructure Upgrades" },
      { feature: "Create work plans and timelines" },
      { feature: "Analyze gaps" },
      { feature: "Configure parameters" },
      { feature: "Migrate data" },
      { feature: "Test system" },
      { feature: "Document system" },
      { feature: "Online Payment Solutions (optional)" },
      { feature: "Advanced Admin Features 2.0" },
      { feature: "User Signup/Login Functionalities" },
      { feature: "Advanced User Features" },
      { feature: "User Profile Management" },
      { feature: "General Configuration Features" },
      { feature: "Complete W3C Certified HTML" },
      { feature: "Complete Deployment" },
    ],
    orderNowBtn: true,
    viewDetailsBtn: true,
    CTACall: ConstantHelper.CTACall,
    CTAChat: ConstantHelper.CTAChat,
  },
  {
    id: "5",
    title: "Startup Website Package",
    overview: "Suitable for static based landing pages.",
    offerPrice: "250",
    actualPrice: "500",
    featuresList: [
      { feature: "5 Stock Photos" },
      { feature: "5 Page Website" },
      { feature: "3 Banner Design" },
      { feature: "1 jQuery Slider Banner" },
      { feature: "FREE Google Friendly Sitemap" },
      { feature: "Complete W3C Certified HTML" },
      { feature: "48 to 72 hours TAT" },
      { feature: "Facebook Page Design" },
      { feature: "Twitter Page Design" },
      { feature: "YouTube Page Design" },
      { feature: "Mobile Responsive will be Additional $99*" },
      { feature: "CMS will be Additional $149*" },
    ],
    orderNowBtn: true,
    viewDetailsBtn: true,
    CTACall: ConstantHelper.CTACall,
    CTAChat: ConstantHelper.CTAChat,
  },
  {
    id: "6",
    title: "Professional Website Package",
    overview:
      "Suitable for basic startups looking to take it one step at a time.",
    offerPrice: "600",
    actualPrice: "1200",
    featuresList: [
      { feature: "10 Page Website" },
      { feature: "CMS / Admin Panel Support" },
      { feature: "8 Stock images" },
      { feature: "5 Banner Designs" },
      { feature: "1 jQuery Slider Banner" },
      { feature: "FREE Google Friendly Sitemap" },
      { feature: "Complete W3C Certified HTML" },
      { feature: "48 to 72 hours TAT" },
      { feature: "Facebook Page Design" },
      { feature: "Twitter Page Design" },
      { feature: "YouTube Page Design" },
      { feature: "Dedicated Project Manager" },
      { feature: "Complete Deployment" },
    ],
    orderNowBtn: true,
    viewDetailsBtn: true,
    CTACall: ConstantHelper.CTACall,
    CTAChat: ConstantHelper.CTAChat,
  },
  {
    id: "7",
    title: "Elite Website Package",
    overview:
      "Suitable for potential startups and basic revamps for small companies.",
    offerPrice: "999",
    actualPrice: "1999",
    featuresList: [
      { feature: "Upto 15 Unique Pages Website" },
      { feature: "Conceptual and Dynamic Website" },
      { feature: "Mobile Responsive" },
      { feature: "Online Reservation/Appointment Tool (Optional)" },
      { feature: "Online Payment Integration (Optional)" },
      { feature: "Custom Forms" },
      { feature: "Lead Capturing Forms (Optional)" },
      { feature: "Striking Hover Effects" },
      { feature: "Newsletter Subscription (Optional)" },
      { feature: "Newsfeed Integration" },
      { feature: "Social Media Integration" },
      { feature: "5 Stock Photos" },
      { feature: "3 Unique Banner Design" },
      { feature: "1 jQuery Slider Banner" },
      { feature: " Complete W3C Certified HTML" },
      { feature: "48 to 72 hours TAT" },
      { feature: "Facebook Page Design" },
      { feature: "Twitter Page Design" },
      { feature: "YouTube Page Design" },
      { feature: "Dedicated Project Manager" },
      { feature: "Complete Deployment" },
    ],
    orderNowBtn: true,
    viewDetailsBtn: true,
    CTACall: ConstantHelper.CTACall,
    CTAChat: ConstantHelper.CTAChat,
  },
  {
    id: "8",
    title: "Silver Website Package",
    overview:
      "Suitable for strong startups that are looking to build a unique brand identity to help them stand apart from their competitors with a strong brand presence and strong brand revamps for companies.",
    offerPrice: "1600",
    actualPrice: "3200",
    featuresList: [
      { feature: "Custom Made, Interactive, Dynamic & High End Design" },
      { feature: "Custom WP (or) Custom PHP Development" },
      { feature: "1 jQuery Slider Banner" },
      { feature: "Up to 10 Custom Made Banner Designs" },
      { feature: "10 Stock Images" },
      { feature: "5 Rounds of Revisions" },
      { feature: "Special Hover Effects" },
      { feature: "Content Management System (CMS)" },
      {
        feature:
          "Online Appointment/Scheduling/Online Ordering Integration (Optional)",
      },
      { feature: "Online Payment Integration (Optional)" },
      { feature: "Multi Lingual (Optional)" },
      { feature: "Custom Dynamic Forms (Optional)" },
      { feature: "Signup Area (For Newsletters, Offers etc.)" },
      { feature: "Search Bar" },
      { feature: "Live Feeds of Social Networks integration (Optional)" },
      { feature: "Mobile Responsive" },
      { feature: "FREE 5 Years Domain Name" },
      { feature: "Free Google Friendly Sitemap" },
      { feature: "Complete W3C Certified HTML" },
      { feature: "Industry Specified Team of Expert Designers and Developers" },
      { feature: "Complete Deployment" },
      { feature: "Dedicated Project Manager" },
      { feature: "Dedicated Accounts Manager" },
      { feature: "Facebook Page Design" },
      { feature: "Twitter Page Design" },
      { feature: "YouTube Page Design" },
    ],
    orderNowBtn: true,
    viewDetailsBtn: true,
    CTACall: ConstantHelper.CTACall,
    CTAChat: ConstantHelper.CTAChat,
  },
];

export default WebDesignPackagesData;
